// extracted by mini-css-extract-plugin
export default {"title":"TradingModal_title__vPM5Y","trades":"TradingModal_trades__0p5iO","trade":"TradingModal_trade__bZTfK","tradeBtn":"TradingModal_tradeBtn__3NZo1"};